export default __webpack_public_path__ + "assets/space_objects.cf68db45.png";